<app-header></app-header>
<div class="hero__upload">
    <div class="container">
        <div class="space-y-20">
            
            <h2 class="title">Dashboard access</h2>

        </div>
    </div>
</div>
 
<div class="container">
    <div class="box in__upload mb-120">

        <div class="row">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">


            <div class="col-lg-6">
                <div class="form-group space-y-10">
                    <div class="space-y-20">
                        <div class="space-y-10">
                            <span class="nameInput">Login</span>
                            <input id="login" formControlName="login" type="text" class="form-control"
                                placeholder="login">
                        </div>
                        <div class="space-y-10">
                            <span class="nameInput">Password </span>
                            <input id="password" formControlName="password" type="password" class="form-control"
                                placeholder="password">
                        </div>
                        <div class="space-y-10">
                            
                        </div>
                        


                    </div>
                </div>
               
            </div>
            <button class="btn btn-sm btn-grad" type="submit">Validate</button>

        </form>
        </div>
    </div>
</div>
 
<app-footer></app-footer>

